module.exports = __webpack_public_path__ + "media/npc_dota_hero_mirana.27baa5ce.webm";